import { render, staticRenderFns } from "./Printer.vue?vue&type=template&id=22a616c8"
import script from "./Printer.vue?vue&type=script&lang=js"
export * from "./Printer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports